import { BASE_URL } from "../config/RequestMethod";

export function getSocketOrigin(): string {
  try {
    return new URL(BASE_URL).origin;
  } catch {
    if (typeof window !== "undefined") return window.location.origin;
    return "";
  }
}
